import { LEGAL_PATHS } from "../../Components/Auth/Legal/legalRules";

export { LEGAL_PATHS };

// The two pages hajexbolt.com showed until the v2026-11 texts, kept word for word.
export const ARCHIVE_PATHS = {
  terms: { "archive-2026-10-30": "/terms/archive/2026-10-30" },
  privacy: { "archive-2026-10-30": "/policy/archive/2026-10-30" },
};

export const versionPath = (type, language, version) =>
  ARCHIVE_PATHS[type]?.[version] ?? `/legal/${type}/${language}/${version}`;

export const DOCUMENT_NAMES = {
  terms: { fr: "Conditions d'utilisation", en: "Terms of Service" },
  privacy: { fr: "Politique de confidentialité", en: "Privacy Policy" },
};

// "30 novembre 2026" / "November 30, 2026"; an unset date is still to be confirmed.
export const formatEffectiveDate = (value, language) => {
  if (!value) {
    return language === "fr" ? "À confirmer" : "To be confirmed";
  }
  const date = new Date(String(value).slice(0, 10) + "T12:00:00Z");
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleDateString(language === "fr" ? "fr-CA" : "en-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
};
